// extracted by mini-css-extract-plugin
export default {"container":"wO-z","error":"xO-z","disabled":"yO-z","submit":"zO-z","option":"AO-z","success":"BO-z","failure":"CO-z"};